import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomDialog from "../../../components/common/CustomDialog";
import CustomButton from "../../../components/common/CustomButton/CustomButton";
import { Eye, EyeOff, X } from "lucide-react";
import CustomTextInput from "../../../components/common/CustomTextInput";

const validationSchema = Yup.object().shape({
  providerName: Yup.string().required("Provider name is required"),
  apiKey: Yup.string().required("API key is required"),
  senderName: Yup.string().required("Sender name is required"),
  senderEmail: Yup.string()
    .email("Invalid email format")
    .required("Sender email is required"),
});

const ProviderForm = ({ open, onClose, editData, onSubmit, type }) => {
  const [showApiKey, setShowApiKey] = useState(false);

  const initialValues = {
    providerName: editData?.providerName || "",
    apiKey: editData?.apiKey || "",
    senderName: editData?.senderName || "",
    senderEmail: editData?.senderEmail || "",
  };

  const handleFormSubmit = (values) => {
    const newProvider = {
      id: editData?.id || Date.now(),
      ...values,
      type: type,
      isActive: false
    };
    onSubmit(newProvider);
  };

  const isEditMode = !!editData?.id;

  return (
    <CustomDialog
      open={open}
      setOpen={onClose}
      title=""
      className="!p-0"
    >
      <div className="w-[500px]">
        {/* Header */}
        <div className="flex justify-between items-center bg-[#0051AD] px-4 py-3 rounded-t-lg">
          <span className="text-sm font-medium text-white">
            {isEditMode ? "Edit Provider" : "New Provider"}
          </span>
          <button 
            type="button"
            onClick={() => onClose(false)}
            className="text-white hover:text-gray-200"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <div className="p-4">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form className="space-y-4">
                <CustomTextInput
                  name="providerName"
                  label="Provider Name"
                  value={values.providerName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.providerName && errors.providerName}
                />

                <div className="relative">
                  <CustomTextInput
                    name="apiKey"
                    label="API Key"
                    type={showApiKey ? "text" : "password"}
                    value={values.apiKey}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.apiKey && errors.apiKey}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
                    onClick={() => setShowApiKey(!showApiKey)}
                  >
                    {showApiKey ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>

                <CustomTextInput
                  name="senderName"
                  label="Sender Name"
                  value={values.senderName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.senderName && errors.senderName}
                />

                <CustomTextInput
                  name="senderEmail"
                  label="Sender Email"
                  type="email"
                  value={values.senderEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.senderEmail && errors.senderEmail}
                />

                <div className="flex justify-end gap-2 pt-4">
                  <CustomButton
                    type="button"
                    label="Cancel"
                    variant="outlined"
                    onClick={() => onClose(false)}
                  />
                  <CustomButton
                    type="submit"
                    label={isEditMode ? "Update" : "Add"}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ProviderForm; 